export default function hidden(window) {
    const VISIBILITY  = 'visibilitychange';
    const UNLOAD = 'unload';

    const CONFIG = {
        capture: true,
        once: true,
        passive: true
    };

    return new Promise(resolve => {
        if (document.hidden) {
            resolve(makeResult(VISIBILITY));
            return;
        }

        window.document.addEventListener(VISIBILITY, ({timeStamp}) => {
            resolve(makeResult(VISIBILITY, timeStamp));
        }, CONFIG);
        window.addEventListener(UNLOAD, ({timeStamp}) => {
            resolve(makeResult(UNLOAD, timeStamp));
        }, CONFIG);

        function makeResult(type, timeStamp = 0) {
            return {
                entryType: 'hidden',
                type,
                startTime: Math.round(timeStamp)
            };
        }
    });
}